import enLang from './entries/enLang';
import thLang from './entries/thLang';
import { addLocaleData } from 'react-intl';

export enum Locale {
  TH = 'th',
  EN = 'en'
}

const options = [
  {
    locale: Locale.TH,
    lang: thLang,
    display: Locale.TH.toUpperCase()
  },
  {
    locale: Locale.EN,
    lang: enLang,
    display: Locale.EN.toUpperCase()
  }
];

function getCurrentLanguage(lang = Locale.TH) {
  let selecetedLanguage = options[0];
  options.forEach((language) => {
    addLocaleData(language.lang.data);
    if (language.locale === lang) {
      selecetedLanguage = language;
    }
  });
  return selecetedLanguage;
}

export function setLanguage(lang: Locale) {
  localStorage.setItem('language', lang);
  window.location.reload();
}

export function getLanguageOptions() {
  return options.map((option) => {
    return {
      value: option.locale,
      label: option.display
    };
  });
}

export default getCurrentLanguage;
